import { render, staticRenderFns } from "./GenAIChatCleanup.vue?vue&type=template&id=50e316bb&scoped=true&"
import script from "./GenAIChatCleanup.vue?vue&type=script&lang=js&"
export * from "./GenAIChatCleanup.vue?vue&type=script&lang=js&"
import style0 from "./GenAIChatCleanup.vue?vue&type=style&index=0&id=50e316bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e316bb",
  null
  
)

export default component.exports